import * as styleguide from "@store/theme/common/styleguide";

export default styleguide;
